export default __webpack_public_path__ + "static/media/a017-market-6.a1d35dff.svg";